import React from "react"
import { get } from "lodash"
import styled from "styled-components"
import withQueryString from "../../highOrderComponents/withQueryString"
/**
 * The FormPane defines the outer area of the Form.
 * It will only show QuestionPanes that are inside its tree. Other dom elements will be ignored.
 */

export const FormNavigationContext = React.createContext({
  processedQuestion: () => {},
})

const PaneContent = styled.div`
  position: relative;
  display: flex;
`

class FormPane extends React.Component {
  state = {
    // FormResult Interface
    result: { ...this.props.queryString, ...this.props.initialState },
    history: [],

    // Form Navigation Interface
    activeIdentifier: null,
    nextQuestionPane: () => {},
    previousQuestionPane: () => {},
    registerQuestionPane: () => {},
    setFields: fieldValues => {
      this.setState({
        result: {
          ...this.state.result,
          ...fieldValues,
        },
      })
    },
    goToIdentifier: (identifier, addToHistory = true) => {
      const previousActiveIdentifier = this.state.activeIdentifier
      if (typeof window !== `undefined`) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }
      const newState = this.props.plugins.reduce(
        (previousResult, currentReducer) => {
          return currentReducer(previousResult, { identifier: null })
        },
        {
          ...this.state,
          activeIdentifier: identifier,
          forward: true,
        }
      )
      this.props.onQuestionProcessed(
        previousActiveIdentifier,
        newState.result[previousActiveIdentifier],
        get(newState, "result")
      )
      this.props.onQuestionView(identifier)

      this.setState({
        // Allow to disable setting a history. This makes sense if a page contains a loading part for example
        ...newState,
        history: addToHistory
          ? [...this.state.history, this.state.activeIdentifier]
          : [...this.state.history],
        forward: true,
      })
    },
    goBack: () => {
      const [...newHistory] = this.state.history
      const lastElement = newHistory.pop()
      if (lastElement) {
        const newState = this.props.plugins.reduce(
          (previousResult, currentReducer) => {
            return currentReducer(previousResult, {
              identifier: null,
              back: true,
            })
          },
          {
            ...this.state,
            history: newHistory,
            activeIdentifier: lastElement,
            forward: false,
          }
        )
        this.setState(newState)
      }
    },
    forward: true,
    navigationVisible: true,
    setNavigationVisibility: visibility =>
      this.setState({ navigationVisible: visibility }),
  }

  // Called when a question was processed and the Reducing should take place.
  onQuestionProcessed = (identifier, value) => {
    const intermediateResult = { ...this.state.result }
    if (identifier && value) {
      intermediateResult[identifier] = value
    }
    console.log(identifier, value)
    const newState = this.props.plugins.reduce(
      (previousResult, currentReducer) => {
        return currentReducer(previousResult, { identifier, value })
      },
      {
        ...this.state,
        forward: true,
        result: intermediateResult,
      }
    )
    this.props.onQuestionProcessed(identifier, value, get(newState, "result"))
    this.props.onQuestionView(newState.activeIdentifier)
    if (typeof window !== `undefined`) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }

    this.setState(newState, () => {
      this.props.onProgress(this.state.percentage)
    })
  }

  componentWillMount() {
    this.onQuestionProcessed()
  }

  render() {
    return (
      <FormNavigationContext.Provider
        value={{
          ...this.state,
          processedQuestion: this.onQuestionProcessed,
        }}
      >
        <div>
          <PaneContent>{this.props.children}</PaneContent>
        </div>
        {this.props.navigation}
      </FormNavigationContext.Provider>
    )
  }
}

FormPane.defaultProps = {
  plugins: [],
  onProgress: () => {},
  queryString: {},
  onQuestionProcessed: () => {},
  onQuestionView: () => {},
}

export default withQueryString(FormPane)
